<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else>
    <Banner
      :background="''"
      :title="!pgLoading ? $t('app.achievements') : ''"
      :subtitle="!pgLoading ? $t('app.achievements') : ''"
    >
    </Banner>

    <section class="blog-area pt-50 pb-50">
      <div class="container">
        <div v-if="pgLoading" class="row">
          <div
            v-for="(item, idx) in 6"
            :key="idx"
            class="col-xl-4 col-lg-4 col-md-6"
          >
            <div
              class="events-02 pos-rel mb-30 wow fadeInUp2 animated webkit-animation webkit-none-270"
            ></div>
          </div>
        </div>

        <div v-if="!pgLoading" class="row">
          <div
            v-for="(row, idx) in rows"
            :key="idx"
            class="col-xl-4 col-lg-4 col-md-6 wow fadeInUp2 animated"
            data-wow-delay=".3s"
          >
            <div class="blog mb-30">
              <a
                :href="row.files[0].file_url"
                target="_blank"
                class="cursor-pointer"
              >
                <iframe
                :src="row.files[0].file_url"
                class="blog__img"
                alt="blog"
                sandbox="allow-scripts allow-same-origin"
                scrolling="no"
                  style="width: 100%; height: 300px; border: none;"
                  title="PDF Preview"
                ></iframe>
              </a>
              <div class="blog__content">
                <h3
                  class="blog-title mb-15 project-desc"
                  style="height: 52px line-height: 1.2"
                >
                <a
                :href="row.files[0].file_url"
                target="_blank"
                class="cursor-pointer"
              >
                    {{ row.title }}
              </a>
                </h3>
                <!-- <p
                  class="mb-25 project-desc"
                  style="height: 55px"
                  v-html="row.body"
                ></p> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <Pagination
          v-if="!pgLoading"
          :currentPage="paginate.currentPage"
          :itemsPerPage="paginate.itemsPerPage"
          :resultCount="paginate.resultCount"
          :nextPage="paginate.nextPage"
          :prevPage="paginate.prevPage"
          v-on:pageChange="handlePageChange"
        >
        </Pagination>
        <!-- End Pagination -->
      </div>
    </section>
  </div>
</template>

<script>
// import iziToast from 'izitoast';
export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    Pagination: () => import("@/components/Pagination.vue"),
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },

      paginate: {
        currentPage: 1,
        itemsPerPage: 9,
        resultCount: 0,
        nextPage: 2,
        prevPage: 0,
      },

      locale: "ar",
      pgLoading: true,
      info: [],
      rows: [],
      whatsNumber: window.whatsNumber,
    };
  },
  mounted() {},
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }

    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //

    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/achievements",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: this.paginate.itemsPerPage,
          page: this.paginate.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;

          // info
          this.info = res.data.info;

          // paginate
          this.paginate.currentPage = res.data.paginate.current_page;
          this.paginate.resultCount = res.data.paginate.total;
          this.paginate.nextPage = res.data.paginate.next_page;
          this.paginate.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => {})
        .finally(() => {});
    },

    handlePageChange(event) {
      this.paginate.currentPage = event.currentPage;
      this.fetchData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
